export interface SubscriptionManagementApiModel {
    Subscriptions: SubscriptionRowNode[];
    LegacyPermissions: boolean;
}

export interface SubscriptionRowNode {
    ID: number;
    Name: string;
    Type: ReportType;
    TypeText: string;
    Folder: string;
    Creator: string;
    Frequency: ScheduleType;
    FrequencyText: string;
    TimeZone: string;
    TimeZoneDefault: boolean;
    Recipients: string[];
    UnsubscribedRecipients: string[];
    ExportType: ExportType;
    ExportTypeText: string;
    RelatedName: string;
    RelatedID: number;
    RelatedKey: string;
    Legacy: boolean;
}

export enum ReportType {
    Dashboard = 0,
    Module = 1,
}

export enum ScheduleType {
    Once = 0,
    DailyWeekly = 1,
    MonthlyDOM = 2,
    MonthlyWOM = 3,
}

export enum ExportType {
    ExcelNoObjectives = 0,
    Excel = 1,
    CSV = 2,
}
